import telegramStart from "../../../assets/sound/telegram-start.mp4";
import telegramStop from "../../../assets/sound/telegram-stop.mp4";
import telegramSend from "../../../assets/sound/telegram-send.mp4";
import telegramCancel from "../../../assets/sound/telegram-cancel.mp4";
import { playAppSound } from "../../../helpers/playAppSound";

export const playStartRecordingSound = () => {
  void playAppSound(telegramStart).catch(() => undefined);
};

export const playStopRecordingSound = () => {
  void playAppSound(telegramStop).catch(() => undefined);
};

export const playSendSound = () => {
  void playAppSound(telegramSend).catch(() => undefined);
};

export const playCancelSound = () => {
  void playAppSound(telegramCancel).catch(() => undefined);
};

export const playHapticFeedback = () => {
  try {
    if ("vibrate" in navigator) {
      navigator.vibrate(50);
    }
  } catch {
    // Vibration unavailable
  }
};

export const playLongHapticFeedback = () => {
  try {
    if ("vibrate" in navigator) {
      navigator.vibrate([100, 50, 100]);
    }
  } catch {
    // Vibration unavailable
  }
};
